import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import {SessionSiteSelectors} from '~selectors/SessionInfoSelectors';
import {getAppStore} from '~src/app/AppStore';

import { Messages } from '../../codegen/Localize';
import { PublishedConnectionTableContentType } from '../../spacesPlatform/models/ContentTypes';
import { TagErrorCode } from '../../ts/helpers/ErrorCodes';
import { ContentUrlForItem } from '../../ts/services/ContentUrl';
import { IPublishedConnectionTableInfo } from '../models/IPublishedConnectionTableInfo';

// TODO: TFSID-1286685 ntomsic figure out what error codes are actually being returned
export enum PublishedConnectionTableErrorCode {
  PublishedConnectionTableNameAlreadyExistsInDestinationProject = -1,
  BadRequest = -2,
  PublishedConnectionTableNotFound = -3,
  InvalidRequest = -4,
  PublishedConnectionTableNameAlreadyExists = -5,
  InternalError = -6,
  ServiceUnavailable = -7,
  ServiceRequestFailed = -8
}

function errorDetailsFor(publishedConnectionErrorItem: IErrorItem<IPublishedConnectionTableInfo>): IErrorDetail {
  return {
    itemName: publishedConnectionErrorItem.item.name,
    itemUrl:
        publishedConnectionErrorItem.error.code === PublishedConnectionTableErrorCode.PublishedConnectionTableNotFound
        ? null
        : ContentUrlForItem(publishedConnectionErrorItem.item, PublishedConnectionTableContentType),
    errorMessage: this.errorMessageFor(publishedConnectionErrorItem)
  };
}

function errorMessageFor(errorItem: IErrorItem<IPublishedConnectionTableInfo>) {
  const publishedConnectionTable = errorItem.item;
  switch (errorItem.error.code) {
    case PublishedConnectionTableErrorCode.PublishedConnectionTableNotFound:
      return Messages.errorPublishedConnectionTableNotFound({PUBLISHED_CONNECTION_TABLE_NAME: publishedConnectionTable.name});
    case PublishedConnectionTableErrorCode.PublishedConnectionTableNameAlreadyExistsInDestinationProject:
      return Messages.errorPublishedConnectionTableNameAlreadyExistsInDestinationProject();
    case TagErrorCode.TooManyTags:
      return Messages.changeTagsErrorTooManyTags({TAG_LIMIT: SessionSiteSelectors.tagLimit(getAppStore().getState())+''});
    default:
      return Messages.errorUnknown();
  }
}

export const PublishedConnectionTableErrors = {
  errorDetailsFor,
  errorMessageFor
};
